export function formatCurrency({ value = 0, currency = '' }: { value: number; currency: string }): string | number {
  if (!currency) {
    return value || 0;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(value || 0);
}
